/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface RequestOrderCreateOne
 */
export interface RequestOrderCreateOne {
  /**
   *
   * @type {string}
   * @memberof RequestOrderCreateOne
   */
  typeOrder: RequestOrderCreateOneTypeOrderEnum
  /**
   *
   * @type {string}
   * @memberof RequestOrderCreateOne
   */
  reason: string
  /**
   *
   * @type {string}
   * @memberof RequestOrderCreateOne
   */
  sum: string
  /**
   *
   * @type {string}
   * @memberof RequestOrderCreateOne
   */
  sourceType: RequestOrderCreateOneSourceTypeEnum
  /**
   *
   * @type {string}
   * @memberof RequestOrderCreateOne
   */
  sourceId?: string
  /**
   *
   * @type {string}
   * @memberof RequestOrderCreateOne
   */
  shopId: string
  /**
   *
   * @type {string}
   * @memberof RequestOrderCreateOne
   */
  shopSalePointId: string
  /**
   *
   * @type {string}
   * @memberof RequestOrderCreateOne
   */
  shopPaymentPointId: string
  /**
   *
   * @type {string}
   * @memberof RequestOrderCreateOne
   */
  parentId?: string
}

/**
 * @export
 */
export const RequestOrderCreateOneTypeOrderEnum = {
  Add: 'ADD',
  Remove: 'REMOVE',
} as const
export type RequestOrderCreateOneTypeOrderEnum =
  (typeof RequestOrderCreateOneTypeOrderEnum)[keyof typeof RequestOrderCreateOneTypeOrderEnum]

/**
 * @export
 */
export const RequestOrderCreateOneSourceTypeEnum = {
  Shops: 'SHOPS',
  Items: 'ITEMS',
  Users: 'USERS',
  Sales: 'SALES',
  Commissions: 'COMMISSIONS',
  Others: 'OTHERS',
  ShopSalePoints: 'SHOP_SALE_POINTS',
  ShopPaymentPoints: 'SHOP_PAYMENT_POINTS',
} as const
export type RequestOrderCreateOneSourceTypeEnum =
  (typeof RequestOrderCreateOneSourceTypeEnum)[keyof typeof RequestOrderCreateOneSourceTypeEnum]

/**
 * Check if a given object implements the RequestOrderCreateOne interface.
 */
export function instanceOfRequestOrderCreateOne(
  value: object,
): value is RequestOrderCreateOne {
  if (!('typeOrder' in value) || value['typeOrder'] === undefined) return false
  if (!('reason' in value) || value['reason'] === undefined) return false
  if (!('sum' in value) || value['sum'] === undefined) return false
  if (!('sourceType' in value) || value['sourceType'] === undefined)
    return false
  if (!('shopId' in value) || value['shopId'] === undefined) return false
  if (!('shopSalePointId' in value) || value['shopSalePointId'] === undefined)
    return false
  if (
    !('shopPaymentPointId' in value) ||
    value['shopPaymentPointId'] === undefined
  )
    return false
  return true
}

export function RequestOrderCreateOneFromJSON(
  json: any,
): RequestOrderCreateOne {
  return RequestOrderCreateOneFromJSONTyped(json, false)
}

export function RequestOrderCreateOneFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestOrderCreateOne {
  if (json == null) {
    return json
  }
  return {
    typeOrder: json['typeOrder'],
    reason: json['reason'],
    sum: json['sum'],
    sourceType: json['sourceType'],
    sourceId: json['sourceId'] == null ? undefined : json['sourceId'],
    shopId: json['shopId'],
    shopSalePointId: json['shopSalePointId'],
    shopPaymentPointId: json['shopPaymentPointId'],
    parentId: json['parentId'] == null ? undefined : json['parentId'],
  }
}

export function RequestOrderCreateOneToJSON(json: any): RequestOrderCreateOne {
  return RequestOrderCreateOneToJSONTyped(json, false)
}

export function RequestOrderCreateOneToJSONTyped(
  value?: RequestOrderCreateOne | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    typeOrder: value['typeOrder'],
    reason: value['reason'],
    sum: value['sum'],
    sourceType: value['sourceType'],
    sourceId: value['sourceId'],
    shopId: value['shopId'],
    shopSalePointId: value['shopSalePointId'],
    shopPaymentPointId: value['shopPaymentPointId'],
    parentId: value['parentId'],
  }
}
